// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + "879303e3f78be2fe2657" + ".js";
};